import React from 'react'
import Launch from '../images/Launching.png'
import Header from './Header'
import Footer from './Footer'

const SignUp = () => {
  return (
    <div>
        <Header/>
        <img src={Launch} alt='Launch img'/>
        <Footer/>
    </div>
  )
}

export default SignUp